import hua from '@hweb/hua-js';
import cookie from 'js-cookie';
import { track } from '@common/utils/ServiceTrack';
import { fetchInternetSource } from '../../universalPages/Api';
import { ToastText, roomnoAuthPopAlert, MhomePageText } from '@common/utils/global.text.config';
import { hzPortalVerConst, UNIVERSAL_CONST } from '@common/utils/constants';
import { getUrlQuery } from '@common/utils/token';
import { previewHost } from '../../universalPages/Api.env.config.js';

const CLICK_A_TAG_DEALY = hua.isIos ? 50 : 200;
const PROD_HOST = 'haoportal.huazhu.com';

export const handleCanaryRedirect = () => {
  const currentHost = window.location.host;
  const currentPathName = window.location.pathname;

  if (currentHost !== previewHost && currentHost === PROD_HOST) {
    //生产环境跳转预发布环境
    window.location.replace(`http://${previewHost}${currentPathName}${window.location.search}`);
    return true;
  }

  if (currentHost !== previewHost && currentHost !== PROD_HOST && getUrlQuery('version') !== 'canary') {
    //测试环境跳转当前域名增加 version 参数
    const search = window.location.search;
    window.location.replace(`http://${currentHost}${currentPathName}?version=canary${search ? `&${search.slice(1)}` : ''}`);
    return true;
  }

  return false;
};

/**
 * 计算天数差
 * @param  {[type]} date1 [description]
 * @param  {[type]} date2 [description]
 * @return {[type]}       [description]
 */
export function getDayOffset(date1, date2) {
  var dayTime;
  dayTime = 1000 * 3600 * 24;
  return Math.floor((date2 - date1) / dayTime);
}

export function formatDate(date) {
  return date.replace(/-/g, '/');
}

export function formatDateQuery(date) {
  return date.replace(/\//g, '-');
}

/**
 * 获取日期
 * @param  {[Number]} count [-1为前一天，0为今天，1为第二天，以此类推]
 * @param  {[type]} date  [description]
 * @param  {[type]} type  [返回类型选择，不填为数字格式如：2017-05-06，1为中文月日如：05月06日，其他为年月日如：2017年05月06日]
 * @return {[type]}       [description]
 */
export function getDateStr(count, date, type) {
  var dd = new Date();
  if (date) {
    dd = new Date(date);
  }
  dd.setDate(dd.getDate() + count);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();

  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  if (type) {
    if (type == 1) {
      return m + '月' + d + '日';
    } else {
      return y + '年' + m + '月' + d + '日';
    }
  } else {
    return y + '.' + m + '.' + d;
  }
}

export function chunk(arr, size) {
  return Array.from({ length: Math.ceil(arr.length / size) }, function(v, i) {
    return arr.slice(i * size, i * size + size);
  });
}

export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }

  var debounced = function() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;

      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}

export function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = '0' + month;
  }
  return m;
}

export function getDayTime(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  // return `${tMonth}/${tDate}/${tYear}`
  return tYear + '-' + tMonth + '-' + tDate;
}

export function scrollFix() {
  setTimeout(() => {
    window.scrollTo(0, document.body.scrollTop + 1);
    document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1);
  }, 10);
}

export function deepClone(obj) {
  let newObj = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === 'object') {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = obj && typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key];
      }
    }
  }
  return newObj;
}

/**
 * 验证手机号码
 * @param num
 * @returns {boolean}
 */
export const isPhone = (num) => {
  const pattern = /^1\d{10}$/;
  const val = Number(num);
  return pattern.test(val);
};

/**
 * 验证姓名
 * @param name
 * @returns {boolean}
 */
export const isName = (name) => {
  const regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
  const regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
  const regNum = /^[0-9]*$/;
  if (name.length < 2) {
    return false;
  }
  if (regCn.test(name) || regEn.test(name)) {
    return false;
  }
  for (let i of name) {
    if (regNum.test(i)) {
      return false;
    }
  }
  return true;
};

export const isNum = (num) => {
  const patrn = /^[1-9][0-9]*$/;
  if (patrn.test(num)) {
    return false;
  }
  return true;
};

// 是否为iphonex等类型手机
export const isHaveBtm = () => {
  if (window.screen.height > 810) {
    return true;
  } else {
    return false;
  }
};

export const filterPhoneNum = (phone = '') => {
  if (phone.length < 7) {
    return phone.substring(0, 1) + '***';
  }
  if (phone.length == 7) {
    return phone.substring(0, 2) + '***' + phone.substring(5, 7);
  }
  if (phone.length == 8) {
    return phone.substring(0, 2) + '***' + phone.substring(5, 8);
  }
  if (phone.length == 9) {
    return phone.substring(0, 2) + '****' + phone.substring(6, 9);
  }
  if (phone.length == 10) {
    return phone.substring(0, 3) + '****' + phone.substring(7, 10);
  }
  if (phone.length == 11) {
    return phone.substring(0, 3) + '****' + phone.substring(7, 11);
  }
};

// 封装cookie及window存储

export const saveCookieAndWindow = (key, value, expires = 0) => {
  if (expires) {
    cookie.set(key, value, {
      expires,
    });
  } else {
    cookie.set(key, value);
  }
  window[`${key}`] = value;
};

export const getCookieAndWindow = (key) => {
  return cookie.get(key) || window[`${key}`] || null;
};

export const removeCookieAndWindow = (key) => {
  cookie.remove(key);
  window[`${key}`] = '';
};

export const wait = (ms) =>
  new Promise((res) => {
    setTimeout(() => res(1), ms);
  });

export const pollCheckPassStatus = async (checkTime = 1500) => {
  const __sTime = Date.now();

  let _status;

  let doCheck = true;

  while (doCheck) {
    let _fetchStartTime = Date.now(),
      _fetchUseTime;
    try {
      _status = await fetchInternetSource('https://cdn.staticfile.net/dayjs/1.11.10/locale/br.min.js');
      if (_status) {
        doCheck = false;
      }
    } catch (e) {}
    if (Date.now() - __sTime >= checkTime) {
      doCheck = false;
    } else {
      _fetchUseTime = Date.now() - _fetchStartTime;
      const _gapTime = 150 - _fetchUseTime;
      if (_gapTime > 0) {
        await wait(_gapTime);
      }
    }
  }

  return _status;
};

// MARK: 探测临时放行状态 七牛云的资源
export const pollCheckPassStatusGlobal = async (checkTime = 3000) => {
  const __sTime = Date.now();

  let _status;

  let doCheck = true;

  while (doCheck) {
    let _fetchStartTime = Date.now(),
      _fetchUseTime;
    try {
      _status = await fetchInternetSource('https://cdn.staticfile.net/dayjs/1.11.10/locale/br.min.js');
      if (_status) {
        doCheck = false;
      }
    } catch (e) {}
    if (Date.now() - __sTime >= checkTime) {
      doCheck = false;
    } else {
      _fetchUseTime = Date.now() - _fetchStartTime;
      const _gapTime = 300 - _fetchUseTime;
      if (_gapTime > 0) {
        await wait(_gapTime);
      }
    }
  }

  return _status;
};

export const filterCountryCode = (data) => {
  let sortCountryMap = new Map(); // 根据图片类型取得大map
  for (let i of data) {
    let result = [];
    if (!sortCountryMap.has(i['languageAlphabet'].slice(0, 1))) {
      sortCountryMap.set(i['languageAlphabet'].slice(0, 1), '');
    } else {
      result = sortCountryMap.get(i['languageAlphabet'].slice(0, 1)) || [];
    }
    result.push(i);
    sortCountryMap.set(i['languageAlphabet'].slice(0, 1), result);
  }
  const sortList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  let newMap = new Map();
  for (let i of sortList) {
    if (sortCountryMap.get(i)) {
      newMap.set(i.toUpperCase(), sortCountryMap.get(i));
    }
  }
  return newMap ? newMap : new Map();
};

export const filterCountryCodeEN = (data) => {
  let sortCountryMap = new Map(); // 根据图片类型取得大map
  for (let i of data) {
    let result = [];
    if (!sortCountryMap.has(i['countryNameEn'].slice(0, 1))) {
      sortCountryMap.set(i['countryNameEn'].slice(0, 1), '');
    } else {
      result = sortCountryMap.get(i['countryNameEn'].slice(0, 1)) || [];
    }
    result.push(i);
    sortCountryMap.set(i['countryNameEn'].slice(0, 1), result);
  }
  const sortList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  let newMap = new Map();
  for (let i of sortList) {
    let _upCaseI = i.toUpperCase();

    if (sortCountryMap.get(_upCaseI)) {
      newMap.set(_upCaseI, sortCountryMap.get(_upCaseI));
    }
  }
  return newMap ? newMap : new Map();
};

const _body = document.body;

export const openAppByATagClick = (schema) => {
  const _tag = document.createElement('a');
  _tag.setAttribute('class', 'hiddenTag');
  _tag.href = schema;
  _body.appendChild(_tag);
  setTimeout(() => {
    _tag.click();
  }, CLICK_A_TAG_DEALY);
};

export const openAppByFrame = (schema) => {
  const _tag = document.createElement('iframe');
  _tag.setAttribute('class', 'hiddenTag');
  _body.appendChild(_tag);
  _tag.src = schema;
};

export const loadTimeUpload = (cb) => {
  if (window.loadTimeUploadFlag || !performance) {
    return;
  }
  window.loadTimeUploadFlag = true;
  const timing = performance.timing;
  const pageLoadTime = new Date() - timing.domLoading;
  cb && cb(pageLoadTime);
};

export const StandCheckPassRes = (response, { hzPortalVer = getUrlQuery('hzPortalVer') }) => {
  let _errMsg = '认证失败';
  const _pageLan = getCookieAndWindow('pageLan');
  if (response && hzPortalVer == hzPortalVerConst.V24) {
    if (response.code == 1) {
      _errMsg = '短信验证码过期';
    }
    if (response.code == 3) {
      _errMsg = '短信验证码过期';
    }
    if (response.code == 4) {
      _errMsg = '短信验证码错误';
    }
    if (response.code == 5) {
      _errMsg = ToastText.notCheckIn[_pageLan];
    }
    // if (response.code == 300201) {
    //   _errMsg = ''
    //   hua.showToast({
    //     title: roomnoAuthPopAlert.content[_pageLan],
    //     mask: true,
    //     icon: 'error',
    //     duration: 3
    //   });
    // }

    if (response && (response.code == 300202 || response.code == 300203 || response.code == 300204 || response.code == 300206)) {
      _errMsg = MhomePageText[response.code][_pageLan];
    }

    if (response.code == 2) {
      hua.hideToast();
      hua.showModal({
        content: '验证码错误次数过多，请您重新获取验证码',
        showCancel: false,
        confirmText: '我知道了',
        onOk() {},
      });
    }
  } else {
    if (response && response.businessCode == 1001) {
      _errMsg = '请稍后再试';
    }
    if (response && response.businessCode == 1011) {
      _errMsg = '短信验证码过期';
    }
    if (response && response.businessCode == 1012) {
      _errMsg = '短信验证码错误';
    }

    if (response && response.businessCode == 2001) {
      _errMsg = '短信验证码依然有效';
    }

    if (response && response.businessCode == 2002) {
      _errMsg = '手机号错误';
    }

    if (response && response.businessCode == 2003) {
      _errMsg = ToastText.notCheckIn[_pageLan];
    }

    if (response && response.businessCode == 300201) {
      _errMsg = '';
      hua.showToast({
        title: roomnoAuthPopAlert.content[_pageLan],
        mask: true,
        icon: 'error',
        duration: 3,
      });
    }

    if (response && (response.businessCode == 300202 || response.businessCode == 300203 || response.businessCode == 300204 || response.businessCode == 300206)) {
      _errMsg = MhomePageText[response.businessCode][_pageLan];
    }

    // if (response && response.businessCode == 1021) {
    //   hua.hideToast();
    //   hua.showModal({
    //     content: '验证码错误次数过多，请您重新获取验证码',
    //     showCancel: false,
    //     confirmText: '我知道了',
    //     onOk() {},
    //   });
    // }
  }

  if (_errMsg) {
    hua.showToast({
      title: _errMsg,
      mask: true,
      icon: 'error',
      duration: 3,
    });
  }
};

export const StandCheckResSendSms = (response) => {
  let _errMsg = '验证码发送失败';

  //1.发送短信频繁
  //2.验证码依然后效
  //3.验证码发送失败
  //0.验证码发送成功

  if (response) {
    if (response.code == 2) {
      _errMsg = '验证码依然有效';
    }
    if (response.code == 3) {
      _errMsg = '验证码发送失败';
    }
  }

  if (_errMsg) {
    hua.showToast({
      title: _errMsg,
      mask: true,
      icon: 'error',
    });
  }
};

export const checkCNPhoneValid = (val) => {
  let _valid = /^1\d{10}$/.test(val);
  return _valid;
};

export const checkRoomNoValid = (val) => {
  let _valid = /^\d+$/.test(val);
  return _valid;
};

export const checkSmsCodeValid = (val) => {
  let _valid = /^\d{4}$/.test(val);
  return _valid;
};

export const getPcPortalWindowWidth = () => {
  let PORTAL_WINDOW_WIDTH = 980;

  PORTAL_WINDOW_WIDTH = window.navigator.userAgent.indexOf('Mac OS') > -1 && window.navigator.userAgent.indexOf('Safari') == -1 ? window.innerWidth : PORTAL_WINDOW_WIDTH;

  PORTAL_WINDOW_WIDTH = window.innerWidth >= 980 ? 980 : window.innerWidth;

  PORTAL_WINDOW_WIDTH = PORTAL_WINDOW_WIDTH < 890 ? 890 : PORTAL_WINDOW_WIDTH;
  return PORTAL_WINDOW_WIDTH;
};

const _PLATFORM = hua.getClientPlatform();

export const h5JumpToWeappPath = (path) => {
  if (_PLATFORM == 'WEB-APP') {
    const WX_SPLITE_REG = /https?:\/\/.+.\//g;

    //ios可以走http链接
    let _wxSchema = hua.isAndroid ? path.replace(WX_SPLITE_REG, 'weixin://dl/business/?t=') : path;

    let _closeTimmer = null;

    //微信 schema 跳转
    hua.showToast({
      title: '请稍后',
      icon: 'loading',
      mask: true,
      duration: 6000,
    });

    let _times = 1;
    const _launchTime = 6 * 1000;

    setTimeout(() => {
      hua.hideToast();
      if (document.visibilityState != 'visible') {
        return;
      } else {
        if (hua.isAndroid) {
          //安卓手机切换打开方式重试一次自动重试一次
          if (_times == 1 && hua.isAndroid) {
            openAppByFrame(_wxSchema);
            _times++;
            setTimeout(() => {
              hua.hideToast();
            }, _launchTime);
          } else {
            track.onEvent('service_portal_not_open_wx_service', {
              open_times: _times,
            });
            hua.hideToast();
          }
        }
      }
    }, _launchTime);

    openAppByATagClick(_wxSchema);
  }
};

export const h5JumpToAppPath = (path) => {
  if (_PLATFORM == 'APP-ANDROID' || _PLATFORM == 'APP-IOS') {
    hua.openAppPage(path);
  } else {
    hua.showToast({
      title: '正在打开华住会APP...',
      icon: 'loading',
      mask: true,
      duration: 6000,
    });

    let _times = 1;
    const _launchTime = 6 * 1000;

    setTimeout(() => {
      hua.hideToast();
      if (document.visibilityState != 'visible') {
        return;
      } else {
        if (hua.isAndroid) {
          //安卓手机切换打开方式重试一次自动重试一次
          if (_times == 1 && hua.isAndroid) {
            openAppByFrame(path);
            _times++;
            setTimeout(() => {
              hua.hideToast();
            }, _launchTime);
          } else {
            track.onEvent('service_portal_not_open_app', {
              open_times: _times,
            });
            hua.hideToast();
          }
        }
      }
    }, _launchTime);

    openAppByATagClick(path);
  }
};

export const getNavgatorLanguage = () => {
  let _currentLan = UNIVERSAL_CONST.PAGE_LAN.CN;

  let __lan = navigator && navigator.language;

  __lan = __lan ? __lan.toLocaleLowerCase() : '';

  if (__lan) {
    if (__lan.indexOf('zh') > -1) {
      _currentLan = UNIVERSAL_CONST.PAGE_LAN.CN;
      // if (/(hk|mo|tw|sg)/.test(__lan)) {
      //   _currentLan = UNIVERSAL_CONST.PAGE_LAN.CN;
      // }
    } else {
      _currentLan = UNIVERSAL_CONST.PAGE_LAN.EN;
    }
  }

  return _currentLan;
};

export const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.onload = () => resolve();

    script.onerror = () => reject(new Error(`Load script from ${url} failed`));

    script.src = url;
    const head = document.head || document.getElementsByTagName('head')[0];
    (document.body || head).appendChild(script);
  });
};

/**
 * 将 wxaurl.cn 格式的 URL 转换为 weixin://dl/business/ 格式的 URL.
 * @param {string} wxaurl - 输入的 wxaurl.cn 链接.
 * @returns {string} - 转换后的 weixin:// 链接.
 */
export function convertToWeixinUrl(wxaurl) {
  try {
    // 使用 URL 对象来解析输入的字符串
    const url = new URL(wxaurl);

    // 提取路径部分，并去掉开头的 '/'
    // 例如: 从 "/GWyHPUFeHAv" 提取出 "GWyHPUFeHAv"
    const t_param = url.pathname.substring(1);

    // 提取查询参数部分
    // 例如: 从 "?cq=uuid%3D62f6c0bd98cd28095a6fb5acf61366b1" 提取出 "cq=uuid%3D62f6c0bd98cd28095a6fb5acf61366b1"
    const query_param = url.search.substring(1);

    // 构建最终的 weixin:// 链接
    let weixinUrl = `weixin://dl/business/?t=${t_param}`;

    // 如果原始链接中存在查询参数，则将其拼接到新链接中
    if (query_param) {
      weixinUrl += `&${query_param}`;
    }

    return weixinUrl;
  } catch (error) {
    // 如果输入的字符串不是一个有效的URL，则会抛出异常
    console.error('无效的URL格式:', error);
    return wxaurl;
  }
}

/**
 * 动态地在页面上添加一个带有特定 URL 和 class 的 iframe。
 *
 * @param {string} url 要加载到 iframe 中的 URL。
 * @returns {HTMLIFrameElement} 创建并添加到页面的 iframe 元素。
 */
export function addHiddenIframe(url) {
  // 1. 创建一个新的 iframe 元素
  const iframe = document.createElement('iframe');

  // 2. 设置 iframe 的 src 属性为传入的 URL
  iframe.src = url;

  // 3. 设置 iframe 的 class 属性为 'classA'
  //    这里使用 className 属性来设置 class
  iframe.className = 'hiddenTag';

  // 可选：设置一些基础属性，如无边框、不显示滚动条等，以保持干净
  // iframe.frameBorder = '0'; // 现代推荐使用 CSS
  // iframe.scrolling = 'no';  // 现代推荐使用 CSS
  iframe.style.border = 'none'; // 移除边框
  iframe.style.width = '100%'; // 示例：设置宽度
  iframe.style.height = '400px'; // 示例：设置高度

  // 4. 将创建好的 iframe 元素添加到页面的 body 中
  //    你可以根据需要添加到其他父元素中，例如 document.getElementById('some-container').appendChild(iframe);
  document.body.appendChild(iframe);

  // 5. 返回创建的 iframe 元素
  return iframe;
}

// 示例用法：
// try {
//     const newIframe = addHiddenIframe(targetUrl);
//     console.log('成功添加 iframe 元素:', newIframe);
// } catch (error) {
//     console.error('添加 iframe 失败:', error);
// }

/**
 * 1. 核心 XHR 轮询方法 (createXhrPoller)
 * -------------------------------------------
 * 接受 url、尝试次数、超时时间、轮询间隔。
 * 返回一个对象 { promise, cancel }
 * - promise: 在成功 (200) 时 resolve(true)，在所有尝试失败或被取消时 resolve(false)。
 * - cancel: 一个函数，用于从外部停止轮询。
 *
 * (已更新：添加 interval 参数控制轮询间隔)
 */
function createXhrPoller(url, maxAttempts = 10, timeout = 1000, interval = 100) { // <-- 新增 interval 参数
  let activeXhr = null;
  let stopped = false;
  let attempts = 0;

  const promise = new Promise((resolve) => {
    
    function attempt() {
      if (stopped) {
        resolve(false); 
        return;
      }

      if (attempts >= maxAttempts) {
        resolve(false); 
        return;
      }
      attempts++;

      activeXhr = new XMLHttpRequest();
      activeXhr.open('GET', url);
      activeXhr.timeout = timeout; 

      // 定义重试逻辑（用于除 200 成功外的所有情况）
      const retry = () => {
        if (stopped) {
          resolve(false);
        } else {
          // “1次请求结束后再开始下一次请求”
          // 并且 "轮询的间隔需要控制在100ms"
          setTimeout(attempt, interval); // <-- 修改点： 0 -> interval
        }
      };

      // --- 设置 XHR 事件处理 ---
      activeXhr.onload = () => {
        if (activeXhr.status === 200) {
          resolve(true); // 成功！
        } else {
          // HTTP 状态码不是 200 (e.g., 404, 500)，重试
          retry();
        }
      };

      activeXhr.onerror = retry;   // 网络错误，重试
      activeXhr.ontimeout = retry; // 超时，重试

      activeXhr.send();
    }

    // 启动第一次尝试
    attempt();
  });

  // 定义取消函数
  const cancel = () => {
    stopped = true;
    if (activeXhr) {
      activeXhr.abort();
    }
  };

  return { promise, cancel };
}

/**
 * 2. 双资源轮询竞速方法 (awaitDualPolling)
 * -------------------------------------------
 * 同时轮询两个资源。
 * 只要有一个成功 (resolve(true))，就立即返回 true，并取消另一个。
 * 如果两个都失败 (resolve(false))，则返回 false。
 */
export const awaitDualPolling = async () => {
  const url1 = 'https://cdn.staticfile.net/dayjs/1.11.10/locale/br.min.js';
  const url2 = 'https://cdn.bootcdn.net/ajax/libs/dayjs/1.11.18/locale/br.min.js';

  const pollInterval = 100; // 轮询间隔 100ms
  const maxAttempts = 10;   // 10次
  const timeout = 1000;     // 1秒超时

  // 创建两个轮询器实例，并传入 100ms 间隔
  const poller1 = createXhrPoller(url1, maxAttempts, timeout, pollInterval);
  const poller2 = createXhrPoller(url2, maxAttempts, timeout, pollInterval);

  // (p1_successOnly 和 p2_successOnly 的定义保持不变)
  const p1_successOnly = poller1.promise.then(success => {
    if (success) return true;
    throw new Error('Poller 1 failed');
  });

  const p2_successOnly = poller2.promise.then(success => {
    if (success) return true;
    throw new Error('Poller 2 failed');
  });

  try {
    // 等待第一个成功的 (Promise.any 会忽略失败的)
    await Promise.any([p1_successOnly, p2_successOnly]);

    // --- 成功 ---
    // 只要有一个成功，就会到这里
    poller1.cancel();
    poller2.cancel();

    return true;

  } catch (error) {
    // --- 失败 ---
    // 只要能进入 Promise.any 的 catch 块，
    // 就意味着所有的 Promise 都被 rejected 了（即两个轮询都失败了）。
    return false;
  }
}


export const adjustmentAccorUrl = ({url, keyToRemove}) => {
if (!url || !keyToRemove) {
        return url;
    }

    // 1. 分离 URL 的基础部分和查询参数部分
    const parts = url.split('?');
    const baseUrl = parts[0];
    const queryString = parts.length > 1 ? parts[1] : '';

    if (!queryString) {
        return url; // 没有查询参数，直接返回原 URL
    }

    // 2. 将查询字符串按 '/' 分隔成参数数组
    // 示例: 'accorParam|abc/roam|1/mac|...' -> ['accorParam|abc', 'roam|1', 'mac|...']
    const paramsArray = queryString.split('/');

    // 3. 过滤掉要移除的参数
    const filteredParams = paramsArray.filter(param => {
        // param 示例: 'accorParam|abc'
        // 使用 | 分隔键值，并检查键名是否匹配
        const keyAndValue = param.split('|');
        const key = keyAndValue[0];

        // 保留键名不等于 keyToRemove 的参数
        return key !== keyToRemove;
    });

    // 4. 重新组合查询字符串
    let newQueryString = '';
    if (filteredParams.length > 0) {
        // 如果还有剩余参数，用 '/' 重新连接
        newQueryString = filteredParams.join('/');
    }

    // 5. 组合新的 URL
    if (newQueryString) {
        // 如果有新的查询参数，加上 ? 和新的参数串
        return baseUrl + '?' + newQueryString;
    } else {
        // 如果所有参数都被移除，则返回不带 ? 的基础 URL
        return baseUrl;
    }
}
